<template>
  <j-modal 
    :title="title" 
    :width="width" 
    :visible="visible" 
    :confirmLoading="confirmLoading" 
    :keyboard="false" 
    :forceRender="true" 
    switchFullscreen 
    @cancel="handleCancel" 
    style="top:20px;height: 95%;"
    >
    <template slot="footer">
      <a-button @click="handleCancel">关闭</a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row class="form-row" :gutter="24">
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="售后服务单号" prop="code">
                  <span>{{form.code}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务日期" prop="date">
                  <span>{{form.date}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="受理人" prop="acceptedBy">
                  <span>{{form.acceptedBy}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="购货者" prop="buyer">
                  <span>{{form.buyer}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人" prop="contacts">
                  <span>{{form.contacts}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话" prop="contactsPhoneNumber">
                  <span>{{form.contactsPhoneNumber}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务内容" prop="service">
                  <span>{{form.service}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编号" prop="productNumber">
                  <span>{{form.productNumber}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称" prop="productName">
                  <span>{{form.productName}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品数量" prop="productNum">
                  <span>{{form.productNum}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="维护人员" prop="keeper">
                  <span>{{form.keeper}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="维护工时" prop="keepTime">
                  <span>{{form.keepTime}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
                  <span>{{form.remark}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系地址" prop="address">
                  <span>{{form.address}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="有无不良事件发生" prop="isBad">
                  <span>{{form.isBad}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上次回访日期" prop="preDate">
                  <span>{{form.preDate}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="维护记录" prop="keepRemark">
                  <span>{{form.keepRemark}}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
        
      </a-form>
    </a-spin>
    <vendor-modal ref="vendorModalForm" @ok="vendorModalFormOk"></vendor-modal>
    <depot-modal ref="depotModalForm" @ok="depotModalFormOk"></depot-modal>
    <batch-set-depot ref="batchSetDepotModalForm" @ok="batchSetDepotModalFormOk"></batch-set-depot>
    <import-item-modal ref="importItemModalForm" @ok="importItemModalFormOk"></import-item-modal>
    <wait-bill-list ref="waitBillList" @ok="waitBillListOk"></wait-bill-list>
    <workflow-iframe ref="modalWorkflow"></workflow-iframe>
  </j-modal>
</template>
<script>
import pick from 'lodash.pick'
import VendorModal from '../../system/modules/VendorModal'
import DepotModal from '../../system/modules/DepotModal'
import BatchSetDepot from '../dialog/BatchSetDepot'
import ImportItemModal from '../dialog/ImportItemModal'
import WorkflowIframe from '@/components/tools/WorkflowIframe'
import { FormTypes } from '@/utils/JEditableTableUtil'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
import { BillModalMixin } from '../mixins/BillModalMixin'
import { getMpListShort } from '@/utils/util'
import JUpload from '@/components/jeecg/JUpload'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import WaitBillList from '../dialog/WaitBillList'
export default {
  name: 'OtherInModal',
  mixins: [JEditableTableMixin, BillModalMixin],
  components: {
    VendorModal,
    DepotModal,
    BatchSetDepot,
    ImportItemModal,
    WaitBillList,
    WorkflowIframe,
    JUpload,
    JDate,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  data() {
    return {
      title: '详情',
      width: '1600px',
      moreStatus: false,
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      visible: false,
      operTimeStr: '',
      prefixNo: 'XJJU',
      fileList: [],
      rowCanEdit: true,
      //出入库管理开关，适合独立仓管场景
      inOutManageFlag: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      refKeys: ['materialDataTable'],
      activeKey: 'materialDataTable',
      confirmLoading: false,
      url: {
        add: '/quality/spotInspection/add',
        edit: '/quality/spotInspection/edit',
        detailList: '/quality/inspectionAssociation/getDetailList',
      },
    }
  },
  created() {},
  methods: {
    show(result){
      this.visible = true
      this.form = result.info
    },
    handleCancel() {
      this.visible = false
    },

  },
}
</script>
<style scoped>
</style>